
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility-statement",
      function () {
        return require("private-next-pages/accessibility-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessibility-statement"])
      });
    }
  